<template>
    <div class="results">
        <h1>{{getTitle}}</h1>
        <div v-if="showTrumpets" class="trumpet left">
            <img :src="getLeftTrumpet" alt>
        </div>
        <div class="colCenter">
            <div v-if="thresholdReached" class="scoreContainer">
                <app-score :score="displayScore" :newScore="newScore"></app-score>
            </div>
            <h2 v-if="showTrumpets && maxLevel == currentLevel && thresholdReached && gameType== 'fruitmachine'" class="completed">
                {{getCompletedBody}}
            </h2>
            <div @click="tryAgain" v-if="showTrumpets && !thresholdReached && gameType=='fruitmachine'" class="orangeButton">
                <h2>Probeer opnieuw</h2>
            </div>
            <a href="https://supermarkt.nl/examen/agfgame" target="_blank">
                <div v-if="showTrumpets && maxLevel == currentLevel && thresholdReached && gameType=='fruitmachine' && showExamLink" class="orangeButton">
                    <h2>Naar het examen<br/></h2>
                </div>
            </a>

            <div @click="tryAgain" v-if="showTrumpets && thresholdReached && gameType=='fruitmachine' && !showExamLink" class="orangeButton">
                <h2>Probeer opnieuw</h2>
            </div>

            <div @click="nextLevel" v-if="showNextLevel && gameType=='fruitmachine'" class="orangeButton">
                <h2>Volgend level</h2>
            </div>



            <h2 v-if="showTrumpets && thresholdReached && gameType== 'training'" class="completed">
                {{getTrainingCompleteBody}}
            </h2>

            <a href="https://supermarkt.nl/examen/agftraining" target="_blank">
                <div v-if="showTrumpets  && thresholdReached && gameType=='training' && showExamLink"  class="orangeButton">
                    <h2>Naar het examen</h2>
                </div>
            </a>


            <div @click="tryAgain" v-if="showTrumpets  && !thresholdReached && gameType=='training'" class="orangeButton">
                <h2>Probeer opnieuw</h2>
            </div>

            <div @click="tryAgain" v-if="showTrumpets  && thresholdReached && gameType=='training' && !showExamLink" class="orangeButton">
                <h2>Probeer opnieuw</h2>
            </div>
        </div>
        <div v-if="showTrumpets" class="trumpet right">
            <img :src="getRightTrumpet" alt>
        </div>
    </div>
</template>

<script>
import { eventBus } from "../main";
import Score from "./score.vue";

export default {
    name: "ResultScreen",
    data() {
        return {
            displayScore: 0,
            scoreInterval: null,
            audioPoints: new Audio(),
            audioVictory: new Audio(),
            audioSad: new Audio(),
            showTrumpets: false
        };
    },
    components: {
        appScore: Score
    },
    props: {
        calculateScore: {
            type: Boolean,
            default: false
        },
        newScore: {
            type: Number,
            default: 0
        },
        maxLevel: {
            type: Number,
            required: true
        },
        currentLevel: {
            type: Number,
            default: 0
        },
        thresholdReached: {
            type: Boolean,
            default: false
        },
        levelStatuses: {
            type:Array,
            required: true
        },
        gameType: {
            type: String,
            required: true
        },
        useLocalStorage: {
            type:Boolean,
            required: true
        },
        showExamLink: {
            type:Boolean,
            required: true
        }
    },
    methods: {
        countToScore() {
            // this.audioPoints.play();
            this.displayScore = 0;
            this.scoreInterval = setInterval(() => {
                this.displayScore++;
                if (this.displayScore == this.newScore) {
                    clearInterval(this.scoreInterval);
                    // this.audioPoints.pause();
                    // this.audioPoints.currentTime = 0;
                    this.showTrumpets = true;
                    eventBus.$emit("updateLevelStatus", 2);
                    // this.audioVictory.play();
                    
                }
            }, 50);
        },
        nextLevel() {
            eventBus.$emit("nextLevel", null);
        },
        tryAgain() {
            eventBus.$emit("tryAgain", null);
        }
    },
    computed: {
        getLeftTrumpet() {
            if (this.thresholdReached) {
                return "../images/trumpet-left.svg";
            } else {
                return "../images/trumpet-left-broken.svg";
            }
        },
        getRightTrumpet() {
            if (this.thresholdReached) {
                return "../images/trumpet-right.svg";
            } else {
                return "../images/trumpet-right-broken.svg";
            }
        },
        getTitle() {
            if (this.thresholdReached) {
                return "Goed gedaan!";
            } else {
                return "Helaas! Je hebt niet genoeg appels gescored...";
            }
        },
        getCompletedBody() {
            if(this.showExamLink) {
                return "Je hebt alle levels uitgespeeld! Doe het examen en behaal je CBL-certificaat!";
            } else {
                return "Je hebt alle levels uitgespeeld! Je mag dit venster nu afsluiten of het nog een keer spelen.";
            }
        },
        getCompletedBody() {
            if(this.showExamLink) {
                return "Doe het examen en behaal je CBL-certificaat!";
            } else {
                return " Je hebt de training goed doorlopen! Je mag dit venster nu afsluiten of het nog een keer spelen.";
            }
        },
        showNextLevel() {
            if(this.levelStatuses[this.currentLevel-1] =="2" && this.showTrumpets == true && this.currentLevel < this.maxLevel) {
                return true
            } else {
                return false
            }
        }
    },
    created() {

    },
    mounted() {
        this.audioPoints.src = "audio/score.mp3";
        this.audioVictory.src = "audio/victory.mp3";
        this.audioSad.src = "audio/sad.mp3";
        if (this.thresholdReached) {
            this.countToScore();
            if(!this.useLocalStorage) {
                if(this.maxLevel == this.currentLevel) {
                    eventBus.$emit("lmsSetComplete");
                }
            }
        } else {
            // this.audioSad.play();
            this.showTrumpets = true;
        }
    }
};
</script>

<style scoped>
h1 {
    margin-top: 10%;
    color: #fff;
}
h2 {
    color: #fff;
    margin-top: 20%;
}
.scoreContainer {
    margin-top: 2%;
    height: 30%;
    width: 100%;
    float: right;
}
.colCenter {
    width: 80%;
    height: 80%;
    margin: 0 auto;
    margin-top: 25%;
}
.results {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    z-index: 300;
    background-color: rgba(0, 0, 0, 0.75);
    /* background-image: url(../assets/images/star.svg); */

    background-position: center;
}

.orangeButton {
    display: inline-block;
    width: 45%;
    height: 25%;
    background-image: url(../assets/images/button-orange-up.svg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    margin-left: 2%;
    margin-right: 2%;
}
.orangeButton:hover {
    cursor: pointer;
}
.trumpet {
    position: absolute;
    top: 30%;
    width: 35%;
    z-index: 800;
}

.left {
    left: -100%;
    animation-name: bounceInLeft;
    animation-duration: 750ms;
    animation-timing-function: linear;
    animation-fill-mode: forwards;
}
.right {
    right: -100%;
    animation-name: bounceInRight;
    animation-duration: 750ms;
    animation-timing-function: linear;
    animation-fill-mode: forwards;
}

@keyframes bounceInLeft {
    0% {
        left: -100%;
    }
    50% {
        left: 0;
    }
    80% {
        left: -15%;
    }
    100% {
        left: -10%;
    }
}

@keyframes bounceInRight {
    0% {
        right: -100%;
    }
    50% {
        right: 0;
    }
    80% {
        right: -15%;
    }
    100% {
        right: -10%;
    }
}
</style>